import { Incarico } from './incarico';
import { Model } from './model';
import { Template } from './template';

export class TipoTemplate extends Model {
  static apiUrl: string = "tipi_template";

  nome: string;

  templates: Template[];


  deserialize(input: any): TipoTemplate {
    let retV: TipoTemplate = new TipoTemplate();
    retV = super.deserialize(input) as TipoTemplate;

    if (input?.templates) {
      retV.templates = input.templates.map(t => new Template().deserialize(t));
    }


    return retV;
  }

  /**
   * Restituisce i templates di questo tipo, ma solo quelli adeguati per l'incarico (compagnia / studio giusto)
   * @param incarico l'incarico per il quale si vuole filtrare i template adeguati
   */
  templatesAdeguatiPerIncarico(incarico: Incarico) {
    if (!this.templates)
      return null;
    let filtrati = this.templates.filter(t => {
      const compagniaUguale = (t.compagnia_id === incarico?.polizza?.compagnia_id)
      const studioUguale = (t.studio_id === incarico?.studio_id);
      //il template viene filtrato in base alla compagnia (se t.compagnia_id è valorizzato)
      //e in base allo studio (se t.studio è valorizzato)
      return (!t.compagnia_id || compagniaUguale) && (!t.studio_id || studioUguale);
    });

    /**
     * Per comodità nell'utilizzo di questa funzione all'interno di un template (evitare di chiamarla due volte)
     * restituisce null se la lunghezza risultante è 0. Così non bisogna accedere al .length ma basta controllare se è truthy o no (js []==true :( )
     */
    if (!filtrati.length)
      return null;
    return filtrati;
  }

}
